module.exports = __webpack_public_path__ + "static/media/back_04.f3808793.png";